import { render, staticRenderFns } from "./productRecalls.vue?vue&type=template&id=009f3296&"
import script from "./productRecalls.vue?vue&type=script&lang=js&"
export * from "./productRecalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports